import { Link } from "react-router-dom";

function ContactCTA() {
  return (
    <section id="contact" className="relative bg-deepgreen text-white px-6 py-24 text-center overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold via-deepgreen to-deepgreen"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto" data-aos="fade-up">
        <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6">Ready to Work With Us?</h2>
        <p className="text-xl text-gray-200 mb-10 leading-relaxed">
          Whether you're facing a legal challenge or planning ahead, our team is here to support you.
          Let’s discuss how we can help.
        </p>
        <Link
          to="/contact"
          className="inline-block bg-gold text-deepgreen font-bold py-4 px-10 rounded-full hover:bg-white hover:text-deepgreen transition duration-300 shadow-lg transform hover:scale-105"
        >
          Schedule a Consultation
        </Link>
      </div>
    </section>
  );
}

export default ContactCTA;
